import React from 'react';
import { ReactComponent as FilterIcon } from '../../icons/filter.svg';
import { ReactComponent as SearchIcon } from '../../icons/search.svg';
import { ReactComponent as CloseCircle } from '../../icons/close-circle.svg';
import './FilterBar.css';

function FilterBar({ 
  filters = {}, 
  onFilterClick, 
  onClearFilters, 
  onRemoveFilter,
  searchValue = '',
  onSearchChange,
  resultsCount = 0,
  activeFilterCount = 0,
  filterChips: customFilterChips = null,
  showFilterButton = true,
  showResultsCount = true
}) {
  const normalizedResultsCount = Number.isFinite(Number(resultsCount)) ? Number(resultsCount) : 0;

  // Get active filter chips to display
  const getFilterChips = () => {
    const chips = [];
    
    if (filters.locationId) {
      chips.push({ key: 'locationId', label: filters.locationId, value: filters.locationId });
    }
    if (filters.categoryId) {
      // Map category ID to name if needed
      const categoryNames = {
        '1': 'Muzyka', '2': 'Film', '3': 'Kultura', '4': 'Sport',
        '5': 'Konferencje', '6': 'Rozrywka', '7': 'Tradycja', '8': 'Warsztaty', '9': 'Sztuka'
      };
      chips.push({ key: 'categoryId', label: categoryNames[filters.categoryId] || `Kategoria ${filters.categoryId}`, value: filters.categoryId });
    }
    if (filters.organizerId) {
      chips.push({ key: 'organizerId', label: filters.organizerId, value: filters.organizerId });
    }
    if (filters.status) {
      const statusNames = { 'active': 'Aktywne', 'inactive': 'Nieaktywne' };
      chips.push({ key: 'status', label: statusNames[filters.status] || filters.status, value: filters.status });
    }
    if (filters.dateFrom) {
      chips.push({ key: 'dateFrom', label: `Od: ${filters.dateFrom}`, value: filters.dateFrom });
    }
    if (filters.dateTo) {
      chips.push({ key: 'dateTo', label: `Do: ${filters.dateTo}`, value: filters.dateTo });
    }
    
    return chips;
  };

  const filterChips = customFilterChips || getFilterChips();
  const hasActiveFilters = filterChips.length > 0;
  const filterCount = customFilterChips ? filterChips.length : activeFilterCount;

  return (
    <div className="filter-bar">
      {/* Left side - Filters and chips */}
      <div className="filter-bar-left">
        {/* Filter button with badge */}
        {showFilterButton && (
          <button className="filter-btn-with-badge" onClick={onFilterClick}>
            <FilterIcon className="filter-btn-icon" />
            {filterCount > 0 && (
              <span className="filter-badge">{filterCount}</span>
            )}
          </button>
        )}

        {/* Clear filters button - only show when filters are active */}
        {hasActiveFilters && (
          <button className="clear-filters-btn" onClick={onClearFilters}>
            Wyczyść filtry
          </button>
        )}

        {/* Filter chips */}
        {filterChips.map((chip) => (
          <div key={chip.key} className="filter-chip">
            <span className="filter-chip-label">{chip.label}</span>
            <CloseCircle 
              className="filter-chip-remove" 
              onClick={() => onRemoveFilter(chip.key)}
            />
          </div>
        ))}

        {/* Results count */}
        {showResultsCount && (
          <span className="results-count">Wyszukano: {normalizedResultsCount} wyników</span>
        )}
      </div>

      {/* Right side - Search input */}
      <div className="filter-bar-right">
        <div className="search-input-container">
          <SearchIcon className="search-input-icon" />
          <input
            type="text"
            className="search-input"
            placeholder="Szukaj"
            value={searchValue}
            onChange={onSearchChange}
          />
        </div>
      </div>
    </div>
  );
}

export default FilterBar;
